import React from 'react';
import { CheckCircle2Icon, MessageSquareIcon, SearchIcon, GlobeIcon } from 'lucide-react';
const JobFinder = () => {
  return <div id="monitoring" className="py-20 bg-white overflow-hidden" data-id="element-212">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-213">
        <div className="flex flex-col lg:flex-row-reverse items-center gap-12" data-id="element-214">
          {/* Text Content */}
          <div className="lg:w-1/2" data-id="element-215">
            <h2 className="text-sm text-accent font-bold tracking-widest uppercase" data-id="element-216">
              AI Search Monitoring
            </h2>
            <h3 className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-customblack sm:text-4xl" data-id="element-217">
              Track Your Brand Across Every AI Engine
            </h3>
            <p className="mt-4 text-lg text-customgray" data-id="element-218">
              See exactly how and where AI search engines mention your brand,
              products, and content in real-time.
            </p>
            <div className="mt-8" data-id="element-219">
              <ul className="space-y-5" data-id="element-220">
                {['Monitor brand mentions across ChatGPT, Perplexity, Gemini, and more', 'Track visibility scores and trends over time', 'Get instant alerts when your brand appears in AI responses', 'Understand which queries trigger your brand mentions'].map((item, i) => <li key={i} className="flex items-start" data-id="element-221">
                    <div className="flex-shrink-0 mt-0.5" data-id="element-222">
                      <CheckCircle2Icon className="h-5 w-5 text-accent" aria-hidden="true" data-id="element-223" />
                    </div>
                    <p className="ml-3 text-base text-customgray font-medium" data-id="element-224">
                      {item}
                    </p>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Mockup */}
          <div className="lg:w-1/2 w-full" data-id="element-225">
            <div className="relative mx-auto w-full max-w-lg rounded-2xl bg-surface border border-gray-800 shadow-2xl overflow-hidden" data-id="element-226">
              {/* Mockup Header */}
              <div className="bg-primary/80 border-b border-gray-800 px-6 py-4 flex justify-between items-center" data-id="element-227">
                <h4 className="text-white font-semibold flex items-center" data-id="element-228">
                  <SearchIcon className="w-4 h-4 mr-2 text-textlight" data-id="element-229" />
                  Mentions Dashboard
                </h4>
                <span className="text-xs font-medium px-2 py-1 rounded bg-accent/20 text-accent border border-accent/20" data-id="element-230">
                  Live Updates
                </span>
              </div>

              {/* Mockup Content */}
              <div className="p-6 space-y-4 bg-gradient-to-b from-surface to-primary/30" data-id="element-231">
                {/* Item 1 */}
                <div className="p-4 rounded-xl bg-primary/50 border border-gray-700 hover:border-gray-500 transition-colors" data-id="element-232">
                  <div className="flex justify-between items-start mb-2" data-id="element-233">
                    <div className="flex items-center space-x-3" data-id="element-234">
                      <div className="w-8 h-8 rounded-full bg-blue-500/20 flex items-center justify-center text-blue-400" data-id="element-235">
                        <GlobeIcon className="w-4 h-4" data-id="element-236" />
                      </div>
                      <div data-id="element-237">
                        <div className="text-sm font-semibold text-white" data-id="element-238">
                          Google AI Overviews
                        </div>
                        <div className="text-xs text-textlight" data-id="element-239">
                          Query: "Best enterprise AEO tools"
                        </div>
                      </div>
                    </div>
                    <span className="text-xs text-green-400 bg-green-400/10 px-2 py-0.5 rounded" data-id="element-240">
                      Positive
                    </span>
                  </div>
                  <p className="text-sm text-gray-300 mt-3 pl-11 border-l-2 border-gray-700 ml-3" data-id="element-241">
                    "...<span className="text-accent font-medium" data-id="element-242">Steward</span>{' '}
                    is highly recommended for enterprise teams looking to
                    optimize for generative search..."
                  </p>
                </div>

                {/* Item 2 */}
                <div className="p-4 rounded-xl bg-primary/50 border border-gray-700 hover:border-gray-500 transition-colors" data-id="element-243">
                  <div className="flex justify-between items-start mb-2" data-id="element-244">
                    <div className="flex items-center space-x-3" data-id="element-245">
                      <div className="w-8 h-8 rounded-full bg-teal-500/20 flex items-center justify-center text-teal-400" data-id="element-246">
                        <MessageSquareIcon className="w-4 h-4" data-id="element-247" />
                      </div>
                      <div data-id="element-248">
                        <div className="text-sm font-semibold text-white" data-id="element-249">
                          ChatGPT (GPT-4)
                        </div>
                        <div className="text-xs text-textlight" data-id="element-250">
                          Query: "How to track AI search visibility"
                        </div>
                      </div>
                    </div>
                    <span className="text-xs text-green-400 bg-green-400/10 px-2 py-0.5 rounded" data-id="element-251">
                      Positive
                    </span>
                  </div>
                  <p className="text-sm text-gray-300 mt-3 pl-11 border-l-2 border-gray-700 ml-3" data-id="element-252">
                    "You can use platforms like{' '}
                    <span className="text-accent font-medium" data-id="element-253">Steward</span> to
                    track your brand's share of voice across various AI
                    models..."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default JobFinder;